import React, { useEffect, useState } from "react"

import {
    Card,
    CardBody,
    Col,
    Row,
    CardTitle,
} from "reactstrap"

import { connect } from "react-redux";

//Import Action to copy breadcrumb items from local state to redux state
import { setBreadcrumbItems } from "../../store/actions";
import Loader from "components/Loader/Loader";
import { toast } from "react-toastify";
import { createCategory, fetchAllCategory } from "helpers/category_helper";
import Select from "react-select"
import { createSubCategory } from "helpers/subCategory_helper";
import { fetchAllCourses } from "helpers/course_helper";
import { all } from "redux-saga/effects";
import { referCourse } from "helpers/refer_helper";

const Refer = (props) => {
    document.title = "Refer & Earn | Refer";




    const breadcrumbItems = [
        { title: "Referrals", link: "#" },
        { title: "Refer", link: "#" },
    ]
    useEffect(() => {
        const blurDiv = document.getElementById("blur");
        var width = window.innerWidth;
        if (width <= 994) {
            blurDiv.click()
        }
    }, [])
    useEffect(() => {
        props.setBreadcrumbItems('Refer', breadcrumbItems)
    })
    const [category, setCategory] = useState(null);
    const [course, setCourse] = useState(null);
    const [studentEmail, setStudentEmail] = useState("");
    const [subCategoryDescription, setSubCategoryDescription] = useState("");
    const [spanDisplay, setSpanDisplay] = useState("none");
    const [loader, setLoader] = useState(false);
    const [categories, setCategories] = useState([]);
    const [allCourses, setAllCourses] = useState([]);


    const fetchCourses = async () => {
        try {
            setLoader(true);
            const data = await fetchAllCourses();
            setLoader(false);
            if (data?.success) {
                setAllCourses(data?.result);
            }
            else {
                toast.error(data?.message);
            }
        } catch (error) {
            setLoader(false);
            toast.error(error?.response?.data?.message);
        }
    }

    useEffect(() => {
        fetchCourses();
    }, []);

    const handleSubmit = async (e) => {

        e.preventDefault();

        try {
            if (!studentEmail || !course) {
                setSpanDisplay("inline");
            }
            else {
                setLoader(true);
                const data = await referCourse({ studentEmail, course });
                setLoader(false);
                if (data?.success) {
                    toast.success(data?.message);
                    setStudentEmail("");
                    setCourse(null);
                }
                else {
                    toast.error(data?.message);
                }
            }
        } catch (error) {
            setLoader(false);
            toast.error(error?.response?.data?.message || "Something went wrong");
        } finally {
            setLoader(false);
        }

    };

    const handleSelectCourse = selectedOption => {
        setCourse(selectedOption);
    };
    return (
        <React.Fragment>
            {loader ? (
                <Loader />
            ) : ("")}
            <Row >
                <Col>
                    <Card>
                        <CardBody className="col-lg-10 col-sm-12 col-xs-12">
                            <CardTitle className="h4">Refer Student</CardTitle>
                            <form onSubmit={handleSubmit}>

                                <Row className="mb-3">
                                    <label
                                        htmlFor="example-text-input"
                                        className="col-md-2 col-form-label"
                                    >
                                        Course
                                    </label>
                                    <div className="col-md-10">
                                        <Select

                                            value={course}
                                            onChange={handleSelectCourse}
                                            options={allCourses}
                                            getOptionLabel={option => option.title}
                                            getOptionValue={option => option.id.toString()} // Convert to string if classId is a number
                                            classNamePrefix="select2-selection"
                                        />
                                        {!course && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                                    </div>

                                </Row>

                                <Row className="mb-3">
                                    <label
                                        htmlFor="example-text-input"
                                        className="col-md-2 col-form-label"
                                    >
                                        Student Email
                                    </label>
                                    <div className="col-md-10">
                                        <input type="text"
                                            className='form-control'
                                            placeholder="Enter Student Email"
                                            value={studentEmail}
                                            maxLength="50"
                                            onChange={(e) => setStudentEmail(e.target.value)} />

                                        {!studentEmail && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                                    </div>
                                </Row>



                                <Row className="mb-3">
                                    <div className="mt-4">
                                        <button type="submit" className="btn btn-primary w-md me-2">Submit</button>
                                    </div>
                                </Row>
                            </form>

                        </CardBody>
                    </Card>
                </Col>
            </Row>



        </React.Fragment>
    )
}

export default connect(null, { setBreadcrumbItems })(Refer);